/*
 * orderForm.js
 *  Parent class for all order forms (orderFormLab, orderFormImaging, etc.)
 *  This provide certain helper methods, and handles the TestCenter functionality
 *  that is common to all Order Forms.
 */

goog.provide('el8.appchart.dialog.order.base');

goog.require('el8.appchart.dialog.order.util');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.mgr.orderForm');
goog.require('el8.appchart.permissions');
goog.require('el8.appservice.notifier');
goog.require('el8.data.base');
goog.require('el8.data.imos');
goog.require('el8.data.orderTests');
goog.require('el8.data.referencedPracticians');
goog.require('el8.ptdata.base');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.confidentialCheckbox');
goog.require('el8.template.appchart.dialog.order');
goog.require('el8.template.mindreader');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.base');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.uiwidget.InputFormDialog');
goog.require('el8.uiwidget.listeditor');
goog.require('el8.util.consts');
goog.require('el8.util.string');


el8.appchart.dialog.order.base = function(options) {
    var that = {
        model : null,
        isMinimized : false,
        dialog : null
    };
    var dialogSpec = options.dialogSpec || {};
    var container = options.container;
    var formContainer = options.formContainer;
    var savedOffsets = null;
    var validateFn = null;
    var closeWidgetsFn = options.closeWidgetsFn || function(){};

    var sitesByCompanyId = {};
    var addressBySiteId = {};

    var detailsTrigger = (options.hasDetailsDiv !== false ) ? $('.order-form-details-trigger', container) : null; // defaults to not null

    var _userModified = false; //used to decide if we should save as draft on close (X)

    // ------------------------------
    // Validate the form's contents before saving
    // ------------------------------
    function validate( order, saveFn ) {
        if( !order.getTestIds() || order.getTestIds().length === 0 ) {
            return { result : false, msg : 'Please input at least one test to order.' };
        } else if( !order.getTestCenterCompanyId() ) {
            return { result : false, msg : 'Please select a test center.' };
        } else if ( !order.getClinicalReason() ) {
            return { result : false, msg : 'Please input a clinical reason.' };
        } else if (!el8.appchart.dialog.order.util.validatePrescribingUser(order)) {
            el8.appchart.dialog.selectPrescribingPhysician.show('orders', function(physicianId) {
                var practiceUser = el8.data.practiceUsers.getByStaffId(physicianId);
                order.setPrescribingUserId(practiceUser.getId());
                if (saveFn) { saveFn(); }
            });
            return {result: false, msg: ''}; // won't actually show an alert dialog
        }

        return validateCcNames(order);
    }
    function validateCcNames( order ) {
        if (order.getCcNames) { // some orders (like referrals) have no CC Names
            var ccNames = order.getCcNames();
            for (var i=0, len=ccNames.length; i < len; i++) {
                if (!ccNames[i]) { continue; } //this happens when CC comes from autoselect

                var validated = el8.util.string.validatePhysicianNameLength(ccNames[i]);
                if (!validated.result) { return validated; }
            }
        }

        return { result : true };
    }

    validateFn = options.validateFn || validate;

    that.getSitesByCompanyId = function getSitesByCompanyId(companyId, type) {
        if (!(sitesByCompanyId[companyId])) {
            $.el8_ajax({
                url : '/orders/test-center-data/'+type+'/'+companyId+'/',
                async : false,
                //dataType : 'json',
                success : function(data, textStatus, xhr) {
                    sitesByCompanyId[companyId] = data;
                }
            });
        }
        return sitesByCompanyId[companyId];
    };

    that.setTestCenterSiteChoices = function setTestCenterSiteChoices(companyId) {
        if( companyId ) {
            var choices = that.getSitesByCompanyId(companyId, options.type) || [];
            // Inserts null option at bottom so default is not to select any site
            options.testCenterSiteSelectField.html(
                // Straight from server
                el8.template.appchart.dialog.order.testCenterSites({choices: choices})
            );
            for(var i=0; i<choices.length; i++) {
                addressBySiteId[choices[i]['id']] = choices[i]['fullAddress'];
            }
        }
        $('.test-center-address', container).text(addressBySiteId[ options.testCenterSiteSelectField.val() ] || '');
        options.testCenterSiteSelectField.change(function() {
            $('.test-center-address', container).text(addressBySiteId[ options.testCenterSiteSelectField.val() ] || '');
        });
    };

    that.initTestCenter = function initTestCenter() {
        options.testCenterCompanySelectField.change( function() {
            that.setTestCenterSiteChoices( $(this).val() );
        });
        options.testCenterSiteSelectField.change( function() {
            if( $(this).val() ) {
                $('.test-center-address', container).text( $(this).attr('address') );
            }
        });
    };

    that.populateTestCenter = function populateTestCenter(model) {
        // First populate order specific information
        if( model.getTestCenterCompanyId() ) {
            options.testCenterCompanySelectField.val( model.getTestCenterCompanyId() );
            that.setTestCenterSiteChoices( model.getTestCenterCompanyId() );
            if( model.getTestCenterSiteId() ) {
                options.testCenterSiteSelectField.val( model.getTestCenterSiteId() ).change();
            }
        }
    };

    that.populateDateForTest = function populateDateForTest(model) {
        var dateForTest = model.getDateForTest();
        if( dateForTest ) {
            try {
                options.dateForTestField.setVal( dateForTest.asString() );
            } catch(error) {}
        }
    };

    that.populateCcs = function populateCcs(model, ccsWidget) {
        var ccIds = model.getCcIds();
        var ccNames = model.getCcNames();
        if( ccIds && ccNames && ccIds.length === ccNames.length ) {
            for( var i=0; i<ccIds.length; i++ ) {
                var cc = el8.data.referencedPracticians.getById(ccIds[i]);
                ccsWidget.addEntry(cc);
            }
        }
    };

    that.populateTestNames = function populateTestNames(model, testsWidget) {
        var testIds = model.getTestIds();
        var testNames = model.getTestNames();
        // Enforce same number of names and ids (should be)
        if( testIds && testNames && testIds.length === testNames.length ) {
            for(var i=0; i<testIds.length; i++) {
                var test = el8.data.orderTests[options.type].getById(testIds[i]);
                testsWidget.addEntry(test);
            }
        }
    };

    that.populateDiagnoses = function populateDiagnoses(model, dxWidget) {
        dxWidget.repopulateFromIdLists({
            icd10Ids: model.getIcd10Ids(),
            icd9Ids: model.getIcd9Ids()
        }, true);
    };

    that.populateTestCenterFields = function populateTestCenterFields( defaults ) {
        var t = options.type.charAt(0).toUpperCase() + options.type.slice(1);
        var testCenterCompanyId = el8.ptdata.ptPreferences['get'+t+'CenterCompanyId']();
        var testCenterSiteId = el8.ptdata.ptPreferences['get'+t+'CenterSiteId']() ;
        if (!testCenterCompanyId && !testCenterSiteId) {
            testCenterCompanyId = (defaults ? defaults['testCenterCompanyId'] : null);
            testCenterSiteId = (defaults ? defaults['testCenterSiteId'] : null);
        }
        if( testCenterCompanyId ) {
            options.testCenterCompanySelectField.val( testCenterCompanyId );
            that.setTestCenterSiteChoices( testCenterCompanyId );
            if( testCenterSiteId ) {
                options.testCenterSiteSelectField.val( testCenterSiteId ).change();
            }
        } else {
            that.setTestCenterSiteChoices(options.testCenterCompanySelectField.val());
        }
    };

    that.populateConfidentiality = function populateConfidentiality(model) {
        var $input = $(':input[name="confidential"]', container);
        $input.prop('checked', model.isConfidential());
    };

    that.extractCcs = function extractCcs(model, ccsWidget) {
        var ccs = ccsWidget.getAllEntries();
        var ccIds = [];
        var ccNames = [];
        ccs.map(function(a) {
            if (a.item) {
                var name = ccsWidget.getItemTextFn(a.item);
                var id = ccsWidget.getItemIdFn(a.item);
                if (name !== a.text) {
                    ccNames.push(a.text);
                    ccIds.push(null);
                } else {
                    ccIds.push(id);
                    ccNames.push(null);
                }
            } else {
                ccNames.push(a.text);
                ccIds.push(null);
            }
        });
        model.setCcIds(ccIds);
        model.setCcNames(ccNames);
    };

    that.extractTests = function extractTests(model, testsWidget) {
        var tests = testsWidget.getAllEntries();
        var testIds = [];
        var testNames = [];
        tests.map(function(a) {
            if (a.item) {
                if (a.item.getName() !== a.text) {
                    testNames.push(a.text);
                    testIds.push(null);
                } else {
                    testIds.push(a.id);
                    testNames.push(null);
                }
            } else {
                testNames.push(a.text);
                testIds.push(null);
            }
        });
        model.setTestIds(testIds);
        model.setTestNames(testNames);
    };

    that.extractDiagnoses = function extractDiagnoses(model, dxWidget) {
        var icdIds = dxWidget.getIcdIdLists();

        model.setIcd9Codes([]);
        model.setIcd9Descs([]);
        model.setIcd9Ids(icdIds.icd9Ids);
        model.setIcd10Ids(icdIds.icd10Ids);
    };

    that.setPrescribingUser = function setPrescribingUser(model) {
        var currUser = el8.data.currUser;
        if (currUser.getOrderDelegatingPhysicianIdsInWorkspace().length) {
            var delegatingPhysicians = currUser.getOrderDelegatingPhysicianIdsInWorkspace();
            if (delegatingPhysicians.length === 1) {
                var practiceUser = el8.data.practiceUsers.getByStaffId(delegatingPhysicians[0]);
                model.setPrescribingUserId(practiceUser.getId());
            }
            // validation will be responsible for catching the case that there's > 1 delegating physician
        } else if (currUser.isPhysician()) {
            model.setPrescribingUserId(currUser.getId());
        }
    };

    that.extractConfidentiality = function extractConfidentiality(model) {
        var $input = $(':input[name="confidential"]', container);
        model.setConfidential($input.is(':checked'));
    };

    // get the show dual coding state from the icd10LE
    that.extractShowDualCoding = function extractShowDualCoding(model) {
        model.setShowDualCoding(that._icd10LE.getShowDualCoding());
    };

    that.extractReminderUserOrGroupId = function (model) {
        var assigneeId = $('.reminder-user-or-group', container).val();
        var ret = el8.data.practiceUsers.extractAssigneeObj(assigneeId);
        model.setReminderUserId(ret.reminderUserId);
        model.setReminderGroupId(ret.reminderGroupId);
    };


    // -----------------------------
    // Initialize the more/less details div
    // -----------------------------
    that.initDetailsDiv = function(expandFn, collapseFn) {
        if (detailsTrigger) {
            el8.uiwidget.collapsible({
                container: $('.order-form-details-section', container),
                triggerElt: detailsTrigger,
                statusElt: detailsTrigger,
                statusTextCollapse: 'more...',
                statusTextExpand: 'less...',
                collapseFn: collapseFn || null,
                expandFn: expandFn || null,
                isCollapsed: true
            });
        }
    };

    // -----------------------------
    // Create the Test field
    // -----------------------------
    that.initTestNames = function initTestNames() {
        var infoField = el8.service.infoField.addInfoField({
            field: $(':input[name="test"]', container),
            infoText: 'tests to be completed...',
            maxLength: 100
        });
        // Enable autocompletion on the Lab Test selection field
        var le = new el8.uiwidget.listeditor({
            list: $('#'+options.type+'-order-tests-list', container),
            editFriendly: true,
            addEntryFn: function() { that.setOrderDialogHeight(); },
            convertTextToItemFn: function(text) {
                var item = el8.data.orderTests[options.type].getByKey(text);
                return item || text;
            },
            getItemTextFn: function(item) { return item.getName(); },
            getItemIdFn: function(item) { return item.getId(); },
            mindreaderOpts: {
                newMindreader: true,
                url: '/s/search/'+options.type+'-order-test/',
                selectFn: function(event, item) {
                    return el8.data.orderTests[options.type].create(item);
                },
                formatResult: function(item) {
                    return el8.template.mindreader.ancillaryTest({item: item});
                },
                formatSelected: function(item) {
                    return item.name || '';
                }
            }
        }).init(infoField);
        return {
            listeditor: le,
            infoField: infoField
        };
    };

    that.initDxs = function() {
        // init a single icd-10 listeditor for this MLE entry and save a reference to it
        var Icd10ListEditorSpecs = {
            // note: no form object here
            listContainer: $('.billing-dxs-container', container),
            onImoSelectFn: function (icd10Le, item, mleIndex) {
                if (item.imo_code) {
                    var imo = el8.data.imos.getByKey(item.imo_code);
                    imo.getAsBillDxMaps().forEach(function(dxMap) {
                        // no need to pass showDualCoding state here since there's only one icd10LE
                        icd10Le.addNewEntry(dxMap);
                    });
                } else if (item.model_class === 'ICD10Code') {
                    var icd10 = el8.data.icd10Codes.create(item);
                    icd10Le.addNewEntry({
                        icd10Code: icd10.asSoyMap()
                    });
                }
            },
            onAddEntry: function() {
                that.setOrderDialogHeight();
            },
            onRemoveEntry: function() { that.setOrderDialogHeight(); },
            index: null // only one LE
        };
        that._icd10LE = (new el8.uiwidget.Icd10ListEditor(Icd10ListEditorSpecs)).init();
        // hack: re-hide the checkbox section, something must be removing it's hidden state...
        $('.dual-coding-checkbox-section', container).hide();
        return that._icd10LE;
    };

    that.initCcsNames = function initCcsNames() {
        var infoField = el8.service.infoField.addInfoField({
            field: $(':input[name="cc"]', container),
            infoText: 'copies of test results to...',
            maxLength: 111
        });
        // Enable autocompletion on the Copies To selection field
        var le = new el8.uiwidget.listeditor({
            list: $('#'+options.type+'-order-ccs-list', container),
            editFriendly: true,
            addEntryFn: function() { that.setOrderDialogHeight(); },
            convertTextToItemFn: function(text) {
                var item = el8.data.referencedPracticians.getByName(text, 'fullName');
                return item || text;
            },
            getItemTextFn: function(item) {
                return (item.getFullName) ? item.getFullName() : item.name;
            },
            getItemIdFn: function(item) {
                return (item.getId) ? item.getId() : item.id;
            },
            mindreaderOpts: el8.appshared.mindreaderOpts.physicians({
                listeditorFriendly: true,
                newContactCb: function(contact) { le.addEntry(contact); }
            })
        }).init(infoField);
        return {
            listeditor: le,
            infoField: infoField
        };
    };

    that.initFollowUpMethod = function initFollowUpMethod(infoField) {
        // Enable autocompletion on the follow up method field.
        // Available values are hardcoded
        var values = [];
        values.push( 'Dr. to call if results are abnormal' );
        values.push( 'Dr. to call if results are abnormal or not' );
        values.push( 'Discuss results during next office visit' );
        values.push( 'Dr. to send note in mail' );

        (new el8.uiwidget.LegacyMindreader({
            data: values,
            limit: 5,
            entryHeight: 25
        }).init(infoField.getInputField()));
    };

    // -----------------------------
    // Methods for holding and deleting orders
    // -----------------------------
    that.holdOrder = function holdOrder( model, dialog, minimize, dont_hide ) {
        options.getOrderFn( model, true );
        that.saveOrder(model, dialog);

        if( !dont_hide ) {
            that.hide();
        }

        if( minimize ) {
            el8.appchart.mgr.orderForm.renderOnHoldOrder( model );
        }
    };

    that.deleteOrder = function deleteOrder(model, dialog, callbackFn) {

        if( model && model.getId() && model.isOnHold() ) {
            el8.appservice.notifier.notify(model.getNotifyText('DELETE_IN_PROGRESS'));
            el8.ptdata.getOrderSet(options.type).deleteItem(model, false, {
                successCb: function() {
                    el8.appservice.notifier.notify(model.getNotifyText('DELETE_COMPLETE'));
                    dialog.enableForms();
                    that.reset();
                    if (callbackFn) { callbackFn(); }
                }
            });
        } else {
            el8.appservice.notifier.notify(model.getNotifyText('DELETE_COMPLETE'));
            dialog.enableForms();
            that.reset();
            if (callbackFn) { callbackFn(); }
        }
    };

    // ------------------------------
    // Methods to save, delete and hold form contents
    // ------------------------------
    that.saveOrder = function saveOrder( model, dialog, opts ) {

        // See if there's a passed saveOrderFn to run, or then do this one
        if (options.saveOrderFn) {
            options.saveOrderFn(model, dialog, opts);
            return true;
        }

        var doPrint = ( opts && opts.doPrint === true );

        function updateUi( order ) {

            el8.ptdata[options.type+'Orders'].add( order );
            el8.appservice.notifier.notify(order.getNotifyText('SAVE_COMPLETE'));

            if( !order.isOnHold() ) {
                // Either add to chart feed or to active visit note
                el8.appchart.mgr.notes.addNewOrder(order);
            }

            var t = options.type.charAt(0).toUpperCase() + options.type.slice(1);
            el8.ptdata.ptPreferences['set'+t+'CenterId'](order.getTestCenterSiteId());
            el8.ptdata.ptPreferences['set'+t+'CenterSiteId'](model.getTestCenterSiteId());
            el8.ptdata.ptPreferences['set'+t+'CenterCompanyId'](model.getTestCenterCompanyId());
        }

        el8.appservice.notifier.notify(model.getNotifyText('SAVE_IN_PROGRESS'));

        // Do save
        $.el8_ajax({
            url: el8.service.urls.get('postOrder', [model]),
            data: JSON.stringify(model.asMap()),
            type: "POST",
            async : !doPrint,
            success: function(data) {
                model.populate(data);
                if( doPrint === true ) {
                    window.open(el8.service.urls.get('printOrder', [model]));
                }
                updateUi( model );
                dialog.enableForms();
                if( !model.isOnHold() ) {
                    that.reset();
                }
                if(el8Globals.FEATURES.BiDiLabs && model.getReminder()){
                    var source = options.type + ' order';
                    el8.util.amplitude.logSetOrderReminder(source);
                }
            }
        });

        return null;
    };

    // We need to hold "savedOffsets" here because re-initializing inputFormDialog
    // renders it unable to "remember" savedOffsets anymore (references get messed up)
    // Only need to hold this information while form is minimized though
    function setSavedOffsets( arr ) {
        savedOffsets = [];
        if( arr && arr.length >= 2 ) {
            savedOffsets[0] = arr[0];
            savedOffsets[1] = arr[1];
        }
    }

    function saveAndCloseFn() {
        that.dialog.disableForms();
        options.getOrderFn( that.model, false );
        var saveFn = function() {
            that.saveOrder(that.model, that.dialog);
            that.dialog.resetForms();
            that.hide();
        };
        var validated = validateFn( that.model, saveFn );
        if( !validated.result ) {
            el8.uiwidget.alert( validated.msg );
            that.dialog.enableForms();
        } else {
            saveFn();
        }
    }
    function saveAsDraftFn(minimize) {
        that.dialog.disableForms();
        options.getOrderFn( that.model, false );
        var validated = validateCcNames( that.model ); //we care about this check because the form will break for over-long names
        if( !validated.result ) {
            el8.uiwidget.alert( validated.msg );
            that.dialog.enableForms();
        } else {
            minimize = (minimize === true); //default to false
            that.holdOrder( that.model, that.dialog, minimize );
            that.isMinimized = true;
        }
    }
    function printAndCloseFn() {
        that.dialog.disableForms();
        options.getOrderFn( that.model, false );
        var saveFn = function() {
            that.saveOrder(that.model, that.dialog, { doPrint: true });
            that.dialog.resetForms();
            that.hide();
        };
        var validated = validateFn( that.model, saveFn );
        if( !validated.result ) {
            el8.uiwidget.alert( validated.msg );
            that.dialog.enableForms();
        } else {
            saveFn();
        }
    }

    function discardFn() {
        that.dialog.disableForms();
        that.deleteOrder(that.model, that.dialog);
        that.dialog.resetForms();
        that.hide();
    }

    function bindKeydowns() {
        $(document).on('keydown', 'ctrl+shift+p', printAndCloseFn);
        $(document).on('keydown', 'ctrl+shift+s', saveAndCloseFn);
    }
    function unbindKeydowns() {
        $(document).unbind('keydown', 'ctrl+shift+p', printAndCloseFn);
        $(document).unbind('keydown', 'ctrl+shift+s', saveAndCloseFn);
    }

    // ------------------------------
    // Define dialog manipulation methods
    // ------------------------------
    that.hide = function hide() {
        that.dialog.hide();
        that.reset();
        unbindKeydowns();
    };

    that.show = function show( setLastPosition, spec ) {
        if (that.dialog.isVisible() && !that.isMinimized && !(spec && spec.model)) {
            // Don't need to do anything if dialog already showing, unless new model
            // being passed in
            return;
        }
        // Have to do this every time dialog is opened
        if (detailsTrigger) {
            that.initDetailsDiv(
                function() {
                    $(dialogSpec.firstFieldSelector, container).focusSelect();
                    that.setOrderDialogHeight();
                },
                function() {
                    $(dialogSpec.firstFieldSelector, container).focusSelect();
                    that.setOrderDialogHeight();
                }
            );
        }

        that.dialog.enableForms();

        function doShow() {
            if( savedOffsets ) {
                that.dialog.show( setLastPosition, savedOffsets );
                savedOffsets = null;
            } else {
                that.dialog.show( setLastPosition );
            }
            that.isMinimized = false;
            that.setOrderDialogHeight();
        }

        if (spec && spec.model) {
            if (!that.isMinimized && that.model) {
                // If form is already populated, confirm before overwriting
                el8.uiwidget.confirm('Do you want to overwrite the contents of the active ' + options.type + ' form?',
                    // If yes over-write...
                    function() {
                        that.deleteOrder(that.model, that.dialog, function() {
                            that.model = spec.model;
                            options.populateFormsFn(that.model, that.dialog);
                            doShow();
                        });
                    },
                    // If no over-write...
                    function() { doShow(); }
                );
            } else {
                that.model = spec.model;
                options.populateFormsFn(that.model, that.dialog);
                doShow();
            }
        } else {
            if( !that.dialog.isVisible() && !that.isMinimized ) {
                options.populateFormsFn(that.model, that.dialog);
            }
            if( !that.model ) {
                that.model = options.newModelFn();
            }
            doShow();
        }
    };

    that.reset = function reset() {
        that.model = null;
        that.isMinimized = false;
        _userModified = false;
        that.dialog.resetForms();
    };

    function minimizeFn( offsets ) {
        // if form is active
        if( that.model && !that.isMinimized ) {
            setSavedOffsets( offsets );
            saveAsDraftFn(true);
        }
    }

    that.minimize = function() {
        that.dialog.minimize();
        unbindKeydowns();
    };

    that.setOrderDialogHeight = function() {
        if (formContainer) {
            that.dialog.setDialogHeight( Math.min(800, formContainer.height() + 55) );
        }
    };



    // --------------------------------------------
    // INITIALIZE the orderForm
    // --------------------------------------------
    that.init = function init() {
        if (options.testCenterCompanySelectField) {
            that.initTestCenter();
        }

        var buttons = {};
        if (el8.appchart.permissions.allow('signOrders')) {
            var printButtonText, signButtonText;
            if (el8.data.currUser.getOrderDelegatingPhysicianIdsInWorkspace().length) {
                printButtonText = 'Print on behalf of physician';
                signButtonText = 'Sign on behalf of physician';
            } else {
                printButtonText = 'Print & Close';
                signButtonText = 'Sign & Close';
            }

            buttons[printButtonText] = [(options.type+'-order-print-btn'), true, printAndCloseFn];
            buttons[signButtonText] = [(options.type+'-order-save-btn'), false, saveAndCloseFn];
        }
        buttons['Save as Draft & Close'] = [options.type+'-order-save-draft-btn', false, saveAsDraftFn];
        buttons['Discard'] = [options.type+'-order-cancel-btn', false,
            function() {discardFn();}];

        dialogSpec = $.extend({
            container: container,
            containerId: 'new-'+options.type+'-order-dialog-container',
            dialogHeight: 372,
            dialogRightMargin: 575,
            dialogBottomMargin: 15,
            dialogWidth: 570,
            title: options.titleHtml,
            buttons: buttons,
            closeFn: function() {
                if (_userModified === true) {
                    saveAsDraftFn();
                } else {
                    that.hide(); //don't create annoying empty drafts
                }
            },
            minimizeFn: minimizeFn,
            disableTitlebarExpand: true,
            makeExpandable: false,
            focus: function(e) {
                unbindKeydowns();
                bindKeydowns();
            },
            firstFieldSelector: ':input[name="test"]'
        }, dialogSpec);

        that.dialog = el8.uiwidget.InputFormDialog(dialogSpec);

        container.on('keydown', ':input[type="text"]',  function() {
            // This is not an accurate measure of whether the form is "dirty"
            // but it's not terrible for a cheap solution
            _userModified = true;
        });


        var super_resetForms = that.dialog.resetForms;
        that.dialog.resetForms = function() {
            super_resetForms();
            closeWidgetsFn();
        };

        var $confidentiality = $('.confidentiality-section', container);
        $confidentiality.html(el8.template.appchart.confidentialCheckbox.content());
        that.setOrderDialogHeight();
    };

    return that;
};
